import Api from '../utils/api';

const api = new Api();

class AffiliateService {
  // ==========================================
  // CANAIS (AFILIADOS)
  // ==========================================

  static async getChannels(token, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = `/channels${queryString ? `?${queryString}` : ''}`;
    return api.get(url, token);
  }

  static async getPendingChannels(token, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = `/channels/pending${queryString ? `?${queryString}` : ''}`;
    return api.get(url, token);
  }

  static async getChannel(id, token) {
    return api.get(`/channels/${id}`, token);
  }

  static async createChannel(data, token) {
    return api.post('/channels', data, token);
  }

  static async updateChannel(id, data, token) {
    return api.put(`/channels/${id}`, data, token);
  }

  static async deleteChannel(id, token) {
    return api.delete(`/channels/${id}`, token);
  }

  static async approveChannel(id, token) {
    return api.post(`/channels/${id}/approve`, {}, token);
  }

  static async rejectChannel(id, token) {
    return api.post(`/channels/${id}/reject`, {}, token);
  }

  // ==========================================
  // LINKS DE AFILIADO
  // ==========================================

  static async getAffiliateLinks(token, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = `/affiliate-links${queryString ? `?${queryString}` : ''}`;
    return api.get(url, token);
  }

  static async getAffiliateLink(id, token) {
    return api.get(`/affiliate-links/${id}`, token);
  }

  static async createAffiliateLink(data, token) {
    return api.post('/affiliate-links', data, token);
  }

  static async updateAffiliateLink(id, data, token) {
    return api.put(`/affiliate-links/${id}`, data, token);
  }

  static async deleteAffiliateLink(id, token) {
    return api.delete(`/affiliate-links/${id}`, token);
  }

  // ==========================================
  // VENDAS
  // ==========================================

  static async getSales(token, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = `/sales${queryString ? `?${queryString}` : ''}`;
    return api.get(url, token);
  }

  static async getSale(id, token) {
    return api.get(`/sales/${id}`, token);
  }

  static async getSalesStats(token, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = `/sales/stats${queryString ? `?${queryString}` : ''}`;
    return api.get(url, token);
  }

  static async getSalesTimeline(token, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = `/sales/stats/timeline${queryString ? `?${queryString}` : ''}`;
    return api.get(url, token);
  }

  static async getSalesByChannel(token, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = `/sales/stats/by-channel${queryString ? `?${queryString}` : ''}`;
    return api.get(url, token);
  }

  static async deleteSale(id, token) {
    return api.delete(`/sales/${id}`, token);
  }

  // ==========================================
  // COMISSÕES
  // ==========================================

  static async getCommissions(token, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = `/commissions${queryString ? `?${queryString}` : ''}`;
    return api.get(url, token);
  }

  static async getCommission(id, token) {
    return api.get(`/commissions/${id}`, token);
  }

  static async getCommissionsStats(token, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = `/commissions/stats${queryString ? `?${queryString}` : ''}`;
    return api.get(url, token);
  }

  static async getAvailableCommission(token) {
    return api.get('/commissions/available', token);
  }

  // Transições de status
  static async confirmPaymentCommission(id, token) {
    return api.put(`/commissions/${id}/confirm-payment`, {}, token);
  }

  static async releaseCommission(id, token) {
    return api.put(`/commissions/${id}/release`, {}, token);
  }

  static async payCommission(id, token) {
    return api.put(`/commissions/${id}/pay`, {}, token);
  }

  static async cancelCommission(id, token) {
    return api.put(`/commissions/${id}/cancel`, {}, token);
  }

  static async bulkReleaseCommissions(ids, token) {
    return api.post('/commissions/bulk-release', { commission_ids: ids }, token);
  }

  static async bulkPayCommissions(ids, token) {
    return api.post('/commissions/bulk-pay', { commission_ids: ids }, token);
  }

  // ==========================================
  // PERFIS DE AFILIADOS
  // ==========================================

  static async getAffiliateProfiles(token, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = `/affiliate-profiles${queryString ? `?${queryString}` : ''}`;
    return api.get(url, token);
  }

  static async getAffiliateProfileMe(token) {
    return api.get('/affiliate-profiles/me', token);
  }

  static async getAffiliateProfile(id, token) {
    return api.get(`/affiliate-profiles/${id}`, token);
  }

  static async createAffiliateProfile(data, token) {
    return api.post('/affiliate-profiles', data, token);
  }

  static async updateAffiliateProfile(id, data, token) {
    return api.put(`/affiliate-profiles/${id}`, data, token);
  }

  static async approveAffiliateProfile(id, token) {
    return api.put(`/affiliate-profiles/${id}/approve`, {}, token);
  }

  static async rejectAffiliateProfile(id, reason, token) {
    return api.put(`/affiliate-profiles/${id}/reject`, { reason }, token);
  }

  static async deleteAffiliateProfile(id, token) {
    return api.delete(`/affiliate-profiles/${id}`, token);
  }

  // ==========================================
  // USUÁRIOS
  // ==========================================

  static async getUserMe(token) {
    return api.get('/users/me', token);
  }

  static async getUsers(token, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = `/users${queryString ? `?${queryString}` : ''}`;
    return api.get(url, token);
  }

  static async getUser(id, token) {
    return api.get(`/users/${id}`, token);
  }

  static async updateUser(id, data, token) {
    return api.put(`/users/${id}`, data, token);
  }

  static async deleteUser(id, token) {
    return api.delete(`/users/${id}`, token);
  }
}

export default AffiliateService;
